import { Component, OnInit } from '@angular/core';
import {ApprovalModel} from '../../shared/dto/approval.model';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {ActivatedRoute} from '@angular/router';
import {TokenStorageService} from '../../shared/service/token-storage.service';

@Component({
  selector: 'app-reversed-suspend-blacklist-request-viewer',
  templateUrl: './reversed-suspend-blacklist-request-viewer.component.html',
  styleUrls: ['./reversed-suspend-blacklist-request-viewer.component.scss']
})
export class ReversedSuspendBlacklistRequestViewerComponent implements OnInit {
  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }


  decodeBase64(code: string): string {
    return atob(code);
  }
}
